import React from 'react';

import classNames from "classnames";
import styles from "./textual-odds.module.scss";
import {observer} from 'mobx-react';
import {TextualOddsCta} from "./textual-odds.cta";

export const TextualOdds = observer(({bettingOpportunity, controller, bookieClickEvent, bookieHrefModel, className, subSource}) => {
  const ctaProps = {
    bookieHrefModel,
    bettingOpportunity,
    controller,
    bookieClickEvent,
    subSource
  }

  return (
    <div className={classNames(styles.textual_odds_container, className)}>
      <div className={classNames(styles.textual_odds_text)}>{bettingOpportunity.text}</div>
      <TextualOddsCta {...ctaProps}/>
    </div>
  )
});
